// LanguageContext.js
import React, { createContext, useState, useContext, useEffect } from "react";
import { translations } from "./Translations";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(() => {
        const saved = localStorage.getItem("abstlanguage");
        return saved ? saved : "en";
    });

    const changeLanguage = (lang) => {
        setLanguage(lang);
        localStorage.setItem("abstlanguage", lang);
    };

    useEffect(() => {
        localStorage.setItem("abstlanguage", language);
    }, [language]);

    return (
        <LanguageContext.Provider
            value={{
                language,
                changeLanguage,
                t: translations[language] || translations.en
            }}
        >
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);